import { UserComponentRegistry } from "ag-grid-community";
import { HeaderComp, IHeaderParams } from "ag-grid-community/dist/lib/headerRendering/cells/column/headerComp";
const holder = {};
UserComponentRegistry.apply(holder);
// @ts-ignore
const agHeaderComp = (holder as UserComponentRegistry).agGridDefaults.agColumnHeader as { new (): HeaderComp };
export class HeaderCompWithNote extends agHeaderComp {
    public init(params: IHeaderParams) {
        super.init(params);
        const element = this.getGui();
        if (element) {
            const littleCornerArrow = document.createElement("span");
            littleCornerArrow.className = "note-arrow";
            element.appendChild(littleCornerArrow);
        }
    }
}
